import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top on route changes EXCEPT when the navigation was triggered by
// the language switcher (which passes state.keepScroll = true).
export default function ScrollToTop() {
  const { pathname, state } = useLocation();

  useEffect(() => {
    if (state && state.keepScroll) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, state]);

  return null;
}
